import React from 'react'
import { IOperationsTabConfig } from '../../types'
import RefundsView from './RefundsView'

/**
 * No fetchMetrics yet; the pending-review count arrives with the Refunds gateway API.
 */
export const refundsTab: IOperationsTabConfig = {
    id: 'refunds',
    labelStringId: 'jsma-web-operations-refundsTabLabel',
    renderContent: () => <RefundsView />,
    // Keep the content mounted across tab switches so the embedded iframe is not reloaded.
    keepMounted: true,
}
